// --- Science Direct Technology ---

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getFormData from 'get-form-data';
import { connect } from 'react-redux';
import { ChooseOrgOptions } from './chooseorgOptions';
import ElsCheckbox from '../ui/elsCheckbox';
import { ArrowButton } from '../../components';
import { submitChooseOrg, displayOrganizations } from '../../../common/actions';

export class ChooseOrgForm extends Component {
  componentDidMount() {
    const {
      displayChooseOrg,
      organizationList,
      choiceAvailable,
    } = this.props;
    if (choiceAvailable && organizationList.length === 0) {
      displayChooseOrg();
    }
  }

  onSubmit = (ev) => {
    ev.preventDefault();

    const {
      onSubmitChooseOrg,
    } = this.props;
    const formData = getFormData(ev.target);
    onSubmitChooseOrg(formData);
  };

  render() {
    const {
      chooseOrgAction,
      showForm,
      organizationList,
    } = this.props;

    const formStyle = {
      display: showForm ? 'block' : 'none',
    };

    return (
      <form
        className="chooseorg-form"
        method="post"
        onSubmit={this.onSubmit}
        style={formStyle}
        action={chooseOrgAction}
      >
        <div className="chooseorg-description">
          <p>
            You currently have access to ScienceDirect through
            multiple organizations. This will determine the ScienceDirect features and entitlements
            available to you in this session.
          </p>
        </div>
        <div className="please-select-one-or">
          <p>Please select one organization from the list below</p>
        </div>
        <ChooseOrgOptions organizationList={organizationList} />
        <p className="els-remember-me-checkbox">
          <ElsCheckbox
            description={'Checking this option will log you in '
                + 'automatically next time you visit ScienceDirect'}
            name="REM_ORG"
            value="Y"
            label="Remember organization"
          />
        </p>
        <div className="chooseorg-submit">
          <ArrowButton className="sd" type="submit">Continue</ArrowButton>
        </div>
      </form>
    );
  }
}

ChooseOrgForm.propTypes = {
  showForm: PropTypes.bool,
  organizationList: PropTypes.array,
  chooseOrgAction: PropTypes.string,
  onSubmitChooseOrg: PropTypes.func,
  displayChooseOrg: PropTypes.func,
  choiceAvailable: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
  onSubmitChooseOrg: (formData) => dispatch(submitChooseOrg(formData)),
  displayChooseOrg: () => dispatch(displayOrganizations()),
});

const mapStateToProps = ({ chooseorg, config }) => ({
  ...chooseorg,
  ...config,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChooseOrgForm);
